export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-7.png?ad21d422929659ba8d01d04a0516a2bc";